import Dashboard from './components/Dashboard';

export default Dashboard;


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/index.js